<div class="flex flex-col gap-4">
  <div class="p-4 flex flex-col items-center gap-2 card">
    <div class="size-[3.5rem] shrink-0">
      <img src="../../../../../../assets/img/my-forest/ganas.svg" class="size-full object-contain" alt="" />
    </div>
    <div class="text-[2.3125rem]/[140%] text-[#003555] font-bold">{{ user()?.balance?.current ?? 0 }}</div>
    <div class="text-[1.125rem]/[160%] text-[#007DCB]">{{ 'my-forest.lifetimeContributedGanas' | translate }}</div>
  </div>
  <div class="flex gap-4 md:flex-row flex-col">
    <div class="p-4 flex flex-1 gap-4 card">
      <div class="size-[3.5rem] shrink-0">
        <img
          src="../../../../../../assets/img/network/shared-ganas-icon-1.svg"
          class="size-full object-contain"
          alt=""
        />
      </div>
      <div class="flex flex-col">
        <div class="text-[0.9375rem]/[160%] text-[#505760]">{{ 'my-forest.youHaveShared' | translate }}</div>
        <div class="text-[1.375rem]/[160%] text-[#393E44] font-bold">{{ ganasShared() }} Ganas</div>
      </div>
    </div>
    <div class="p-4 flex flex-1 gap-4 card">
      <div class="size-[3.5rem] shrink-0">
        <img src="../../../../../../assets/img/my-forest/ganamigo-shared.svg" class="size-full object-contain" alt="" />
      </div>
      <div class="flex flex-col">
        <div class="text-[0.9375rem]/[160%] text-[#505760]">{{ 'my-forest.yourGanamigoHasShared' | translate }}</div>
        <div class="text-[1.375rem]/[160%] text-[#393E44] font-bold">{{ ganamigoGanasShared() }} Ganas</div>
      </div>
    </div>
  </div>
</div>
